export default "/_next/static/sounds/vanna-weareover-92ea596cae522ea241495a964fa90bbb.mp3";